module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入小程序名称"
    },
    model: {
      value: (_vm.inputKW),
      callback: function($$v) {
        _vm.inputKW = $$v
      },
      expression: "inputKW"
    }
  }, _vm._l((_vm.applist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.placement ? item.name + '--' + item.placement : item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.change(item)
        }
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b5f1f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchApp.vue
// module id = 1084
// module chunks = 2